import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from './services/queryClient';

// Setup global axios interceptors for authentication handling
import './services/axiosInterceptor';

// One-shot dayjs setup (utc + timezone + relativeTime plugins). Must
// import here so the plugins are attached before any component first
// calls dayjs.tz(...) or dayjs(value).fromNow().
import './timezone/dayjsInit';
import { installZonedDateLocale } from './timezone/installZonedDateLocale';

// Date#toLocale*String() defaults to the RESOLVED zone (user -> org ->
// detected) instead of the laptop's, for the ~125 display sites and chart
// tooltips that call it without a timeZone. Explicit timeZone is respected.
installZonedDateLocale();

// Suppress ResizeObserver loop limit warning globally
const observerErrorHandler = (e) => {
  if (e.message && e.message.includes('ResizeObserver loop')) {
    e.stopImmediatePropagation();
  }
};
window.addEventListener('error', observerErrorHandler);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename="/">
        <App />
      </BrowserRouter>
      {/* React Query DevTools - only visible in development */}
      {process.env.NODE_ENV === 'development' && (
        <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
      )}
    </QueryClientProvider>
  </React.StrictMode>
);
